import React, { useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
} from "reactstrap";
import classnames from "classnames";
import PageLayout from "./PageLayout";
import JournalCard from "./components/journalCard";
import ReviewerCard from "./components/ReviewerCard";
import { useLocation, useNavigate } from "react-router-dom";

const HomePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const defaultTab = searchParams.get("tab") || "journals";
  const [iconTabs, setIconTabs] = useState(defaultTab);

  const [birthdayFocused, setBirthdayFocused] = useState(false);

  const [name, setName] = useState("");

  const [searchQuery, setSearchQuery] = useState("");

  const toggleNavs = (e, state, index) => {
    e.preventDefault();
    setIconTabs(index);
    navigate(`?tab=${index}`);
  };
  useEffect(() => {
    setIconTabs(defaultTab);
  }, [defaultTab]);

  const handleSearch = () => {
    setName(searchQuery);
  };

  return (
    <>
      <PageLayout>
        <div className="nav-wrapper m-4">
          <Nav
            className="nav-fill flex-column flex-md-row"
            id="tabs-icons-text"
            pills
            role="tablist"
          >
            <NavItem>
              <NavLink
                aria-selected={iconTabs === "journals"}
                className={classnames("mb-sm-3 mb-md-0", {
                  active: iconTabs === "journals",
                })}
                onClick={(e) => toggleNavs(e, "iconTabs", "journals")}
                href="#pablo"
                role="tab"
              >
                <i className="ni ni-cloud-upload-96 mr-2" />
                Journals
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                aria-selected={iconTabs === "reviewers"}
                className={classnames("mb-sm-3 mb-md-0", {
                  active: iconTabs === "reviewers",
                })}
                onClick={(e) => toggleNavs(e, "iconTabs", "reviewers")}
                href="#pablo"
                role="tab"
              >
                <i className="ni ni-bell-55 mr-2" />
                Faculties/Reviewers
              </NavLink>
            </NavItem>
          </Nav>
        </div>

        <Card className="shadow m-4">
          <CardBody>
            <TabContent activeTab={iconTabs}>
              <TabPane tabId="journals">
                {/* Search */}

                <FormGroup className={classnames({ focused: birthdayFocused })}>
                  <InputGroup className="mb-4 p-4">
                    <Input
                      placeholder="Search by Name"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onFocus={() => setBirthdayFocused(true)}
                      onBlur={() => setBirthdayFocused(false)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                    <InputGroupText onClick={() => handleSearch()}>
                      <i className="ni ni-zoom-split-in" />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>

                <JournalCard searchQuery={name} />
              </TabPane>
              <TabPane tabId="reviewers">
                {/* Reviewer Search Bar */}
                <FormGroup className={classnames({ focused: birthdayFocused })}>
                  <InputGroup className="mb-4 p-4">
                    <Input
                      placeholder="Search by Name"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onFocus={() => setBirthdayFocused(true)}
                      onBlur={() => setBirthdayFocused(false)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                    <InputGroupText>
                      <i className="ni ni-zoom-split-in" />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>

                {/* Pass the search query to ReviewerCard */}
                <ReviewerCard searchQuery={name} />
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </PageLayout>
    </>
  );
};

export default HomePage;
